// extracted by mini-css-extract-plugin
module.exports = {"root":"SpCalendarTypeSelect_root__JpJ3S","button":"SpCalendarTypeSelect_button__lkfcb","isSelected":"SpCalendarTypeSelect_isSelected__0SAeq"};